import { Button, Link } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  backgroundColor: alpha(theme.palette.error.main, 0.3),
  borderBottom: `2px solid ${theme.palette.error.main}`,
  position: 'relative',
  height: 0,
  opacity: 0.0,
  transition: 'all 0.75s ease',

  '&.visible': {
    padding: theme.spacing(2),
    height: 'auto',
    marginTop: 0,
    marginBottom: 0,
    opacity: 1.0,
  },
  '&.isListOption': {
    paddingLeft: 0,
  },
}));

export const Row = styled('div')({
  display: 'flex',
  flexDirection: 'row',
});

export const IconCol = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  marginTop: -6,
});

export const ContentCol = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: `0 ${theme.spacing(1)}`,
}));

export const TextWrapper = styled('div')({
  fontWeight: 'bold',
});

export const DisplayText = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ isMobile }) => ({
  height: isMobile ? 80 : 37,
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  fontSize: 14,
}));

export const LinkButton = styled(Link)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.secondary.main,
  marginLeft: theme.spacing(1),
}));

export const ButtonContainer = styled(Row, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  marginLeft: isMobile ? 10 : undefined,
  [theme.breakpoints.up('md')]: {
    marginLeft: 50,
  },
  '& .MuiButton-root + .MuiButton-root': {
    marginLeft: theme.spacing(1),
  },
}));

export const SentMessageText = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));
